import moment from 'moment';
import { createContext, useContext } from 'react';

interface IReportBuilderContext {
  endDate: moment.Moment;
  reportTypeID: number;
  startDate: moment.Moment;
  timezone: string;
}

export const ReportBuilderContext = createContext({} as IReportBuilderContext);
export const useReportBuilderStore = (): IReportBuilderContext => useContext(ReportBuilderContext);
